import React from "react";
import { ReactComponent as SearchSVG } from "App/common/icons-v2/search.svg";
import { LoadingSpinner } from "App/common/icons/LoadingSpinner";
import { TextInputV2 } from "App/common/TextInput/TextInputV2";
import { useSearchContext } from "./useEntities/useSearchContext";

export const SearchEntityInput = () => {
  const {
    isSearchClientLoading,
    isSearchClientLoaded,
    searchValue,
    isSearching,
    searchError,
    handleChange,
  } = useSearchContext();

  // The input is intentionally NOT disabled while the Algolia client loads.
  // Disabled inputs can't receive focus, which would break autoFocus on
  // mount. Typing while the client loads is safe — handleChange updates the
  // local value, and the debounced search no-ops when the client is missing.

  return (
    <TextInputV2
      autoFocus
      hideLabel
      label="Search"
      inputType="input"
      value={searchValue}
      onChange={handleChange}
      placeholder={
        isSearchClientLoading || !isSearchClientLoaded
          ? "Loading Search..."
          : "Search"
      }
      startComponent={<SearchSVG />}
      endComponent={
        isSearching || isSearchClientLoading ? <LoadingSpinner /> : null
      }
      error={searchError}
    />
  );
};
